const paletteColours = [
  {
    name: "Vintage Black",
    id: "vintageblack",
    slug: "vintage-black",
    hex: "#303030"
  },
  {
    name: "Lake Stone",
    id: "lakestone",
    slug: "lake-stone",
    hex: "#515151"
  },
  {
    name: "Cabin Smoke",
    id: "cabinsmoke",
    slug: "cabin-smoke",
    hex: "#554b45"
  },
  {
    name: "Pine Bark",
    id: "pinebark",
    slug: "pine-bark",
    hex: "#695c54"
  },
  {
    name: "Campfire Ash",
    id: "campfireash",
    slug: "campfire-ash",
    hex: "#7e6a5f"
  },
  {
    name: "Misty Lake",
    id: "mistylake",
    slug: "misty-lake",
    hex: "#6b8288"
  },
  {
    name: "Deep Water",
    id: "deepwater",
    slug: "deep-water",
    hex: "#516266"
  },
  {
    name: "Storm Cloud",
    id: "stormcloud",
    slug: "storm-cloud",
    hex: "#6b7888"
  },
  {
    name: "Lake Depths",
    id: "lakedepths",
    slug: "lake-depths",
    hex: "#536070"
  },
  {
    name: "Lily Pad",
    id: "lilypad",
    slug: "lily-pad",
    hex: "#6c8a84"
  },
  {
    name: "Mossy Rock",
    id: "mossyrock",
    slug: "mossy-rock",
    hex: "#727a61"
  },
  {
    name: "Forest Floor",
    id: "forestfloor",
    slug: "forest-floor",
    hex: "#5b624e"
  },
  {
    name: "Fern Green",
    id: "ferngreen",
    slug: "fern-green",
    hex: "#657a61"
  },
  {
    name: "Beaver Dam",
    id: "beaverdam",
    slug: "beaver-dam",
    hex: "#51624e"
  },
  {
    name: "Marsh Grass",
    id: "marshgrass",
    slug: "marsh-grass",
    hex: "#617a6d"
  },
  {
    name: "Sunset Berry",
    id: "sunsetberry",
    slug: "sunset-berry",
    hex: "#906363"
  },
  {
    name: "Dockside Red",
    id: "dockangered",
    slug: "dockside-red",
    hex: "#774a4a"
  },
  {
    name: "Ember Glow",
    id: "emberglow",
    slug: "ember-glow",
    hex: "#853d3d"
  },
  {
    name: "Dusky Rose",
    id: "duskyrose",
    slug: "dusky-rose",
    hex: "#816670"
  },
  {
    name: "Berry Stain",
    id: "berrystain",
    slug: "berry-stain",
    hex: "#644c54"
  },
  {
    name: "Wild Orchid",
    id: "wildorchid",
    slug: "wild-orchid",
    hex: "#796a7d"
  },
  {
    name: "Plum Shadow",
    id: "plumshadow",
    slug: "plum-shadow",
    hex: "#615564"
  },
  {
    name: "Old Timber",
    id: "oldtimber",
    slug: "old-timber",
    hex: "#98765a"
  },
  {
    name: "Rustic Hide",
    id: "rustichide",
    slug: "rustic-hide",
    hex: "#7a5e48"
  },
  {
    name: "Rusty Paddle",
    id: "rustypaddle",
    slug: "rusty-paddle",
    hex: "#915b47"
  }
];

const paletteIconColours = [
  {
    name: "Dock Grey",
    id: "dockgrey",
    slug: "dock-grey",
    hex: "#ababab"
  },
  {
    name: "Pebble Shore",
    id: "pebblashore",
    slug: "pebble-shore",
    hex: "#c5c5c5"
  },
  {
    name: "Driftwood Beige",
    id: "driftwoodbeige",
    slug: "driftwood-beige",
    hex: "#c0b3a3"
  },
  {
    name: "Birch Bark",
    id: "birchbark",
    slug: "birch-bark",
    hex: "#d4cabe"
  },
  {
    name: "Lake Sparkle",
    id: "lakesparkle",
    slug: "lake-sparkle",
    hex: "#6fc2ce"
  },
  {
    name: "River Mist",
    id: "rivermist",
    slug: "river-mist",
    hex: "#97c3ca"
  },
  {
    name: "Sky Reflection",
    id: "skyreflection",
    slug: "sky-reflection",
    hex: "#b4d4d9"
  },
  {
    name: "Deep Dive",
    id: "deepdive",
    slug: "deep-dive",
    hex: "#57afec"
  },
  {
    name: "Blue Heron",
    id: "blueheron",
    slug: "blue-heron",
    hex: "#83b2d3"
  },
  {
    name: "Cloud Cover",
    id: "cloudcover",
    slug: "cloud-cover",
    hex: "#b0cce0"
  },
  {
    name: "Fresh Moss",
    id: "freshmoss",
    slug: "fresh-moss",
    hex: "#acca7c"
  },
  {
    name: "Willow Branch",
    id: "willowbranch",
    slug: "willow-branch",
    hex: "#b8cb9d"
  },
  {
    name: "Forest Green",
    id: "forestgreen",
    slug: "forest-green",
    hex: "#90ca7c"
  },
  {
    name: "Fern Shoot",
    id: "fernshoot",
    slug: "fern-shoot",
    hex: "#afd6a1"
  },
  {
    name: "Sunset Amber",
    id: "sunsetamber",
    slug: "sunset-amber",
    hex: "#d98d4a"
  },
  {
    name: "Cedar Stain",
    id: "cedarstain",
    slug: "cedar-stain",
    hex: "#c9a479"
  },
  {
    name: "Sand Dune",
    id: "sanddune",
    slug: "sand-dune",
    hex: "#d5bea4"
  },
  {
    name: "Campfire Red",
    id: "campfirered",
    slug: "campfire-red",
    hex: "#d94a4a"
  },
  {
    name: "Berry Blush",
    id: "berryblush",
    slug: "berry-blush",
    hex: "#c97979"
  },
  {
    name: "Peach Haze",
    id: "peachhaze",
    slug: "peach-haze",
    hex: "#dba4a4"
  },
  {
    name: "Wild Azalea",
    id: "wildazalea",
    slug: "wild-azalea",
    hex: "#da96b9"
  },
  {
    name: "Lilac Bloom",
    id: "lilacbloom",
    slug: "lilac-bloom",
    hex: "#e0b6d3"
  },
  {
    name: "Berry Burst",
    id: "berryburst",
    slug: "berry-burst",
    hex: "#ec5a94"
  },
  {
    name: "Heather Plum",
    id: "heatherplum",
    slug: "heather-plum",
    hex: "#c9a0dc"
  },
  {
    name: "Grape Mist",
    id: "grapemist",
    slug: "grape-mist",
    hex: "#ccb1d8"
  }
];

// palette main

function transformPaletteColours(paletteColours) {
  const paletteRaw = [];
  let currentSubArray = [];

  for (const colourObject of paletteColours) {
    currentSubArray.push(colourObject.hex);
    if (currentSubArray.length === 5) {
      paletteRaw.push(currentSubArray);
      currentSubArray = [];
    }
  }

  // Add any remaining colours if the total wasn't a multiple of 5
  if (currentSubArray.length > 0) {
    paletteRaw.push(currentSubArray);
  }

  return paletteRaw;
}

const paletteRaw = transformPaletteColours(paletteColours);


function findNameByHex(hexValue, paletteColours) {
  // Convert the input hex value to lowercase for case-insensitive comparison
  const lowerCaseHex = hexValue.toLowerCase();

  // Iterate through the paletteColours array
  for (const colourObject of paletteColours) {
    // Convert the hex value in the object to lowercase for comparison
    if (colourObject.hex.toLowerCase() === lowerCaseHex) {
      return colourObject.name; // Return the 'name' if a match is found
    }
  }

  // If no matching hex value is found, return null or a default message
  return null; // Or you could return "Colour name not found"
}


// palette icon

function transformPaletteIconColours(paletteIconColours) {
  const paletteIconRaw = [];
  let currentSubArray = [];

  for (const colourObject of paletteIconColours) {
    currentSubArray.push(colourObject.hex);
    if (currentSubArray.length === 5) {
      paletteIconRaw.push(currentSubArray);
      currentSubArray = [];
    }
  }

  // Add any remaining colours if the total wasn't a multiple of 5
  if (currentSubArray.length > 0) {
    paletteIconRaw.push(currentSubArray);
  }

  return paletteIconRaw;
}

const paletteIconRaw = transformPaletteIconColours(paletteIconColours);


function findIconNameByHex(hexValue, paletteIconColours) {
  // Convert the input hex value to lowercase for case-insensitive comparison
  const lowerCaseHex = hexValue.toLowerCase();

  // Iterate through the paletteColours array
  for (const colourObject of paletteIconColours) {
    // Convert the hex value in the object to lowercase for comparison
    if (colourObject.hex.toLowerCase() === lowerCaseHex) {
      return colourObject.name; // Return the 'name' if a match is found
    }
  }

  // If no matching hex value is found, return null or a default message
  return null; // Or you could return "Colour name not found"
}
